import { CardFooter, Col } from "reactstrap";
import { BasicCancleButton, BasicSubmitButton } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";

export const BasicHtmlCardFooter = () => {
  return (
    <CardFooter className="text-end">
      <Col sm="9" className="offset-sm-3">
        <Btn color="primary" className="me-3">
          {BasicSubmitButton}
        </Btn>
        <Btn color="light" type="reset">
          {BasicCancleButton}
        </Btn>
      </Col>
    </CardFooter>
  );
};
